import React from 'react';

import BaseFilterChip from './BaseFilterChip';

type Props = {
  value?: string | null;
  onDelete: () => void;
};
export default function SearchFieldFilterChip({ value, onDelete }: Props) {
  const v = value?.trim();
  if (!v || v.length === 0) {
    return null;
  }
  return <BaseFilterChip label={`Search: ${v}`} onDelete={onDelete} />;
}
